var formatRelativeLocale = {
  lastWeek: "eeee 'diwethaf am' p",
  yesterday: "'ddoe am' p",
  today: "'heddiw am' p",
  tomorrow: "'yfory am' p",
  nextWeek: "eeee 'am' p",
  other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};
export default formatRelative;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_date-fns@2.30.0@date-fns/esm/locale/cy/_lib/formatRelative/index.js
// module id = null
// module chunks = 